exports = module.exports = require("../../node_modules/.pnpm/registry.nlark.com+css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home{padding:30px}h3{margin-top:20px}h3,p{text-align:center}p{margin-top:10px}", ""]);

// exports
